// extracted by mini-css-extract-plugin
export var externalLink = "_7a-0";
export var internalLinkLabel = "_7a-1";